import type { ReactNode } from 'react'

import type { Schwere } from '../typen'

interface Eigenschaften {
  art?: Schwere | 'gut'
  titel?: string
  children: ReactNode
}

/** Kurzer Kasten fuer Fehler, Warnungen und Bestaetigungen. Traegt immer Text, nie nur Farbe. */
export default function Meldung({ art = 'hinweis', titel, children }: Eigenschaften) {
  return (
    <div className={`meldung ${art}`}>
      {titel && <b>{titel}</b>}
      {children}
    </div>
  )
}
